import { useMemo } from 'react';

import { useUsersByOxygenIdMap } from '.';

export default () => {
  const { data: usersMapByOxygenID, loading: isLoadingUsersMap } =
    useUsersByOxygenIdMap();

  const data = useMemo(() => {
    if (!usersMapByOxygenID) return undefined;
    const mapping = {};
    for (const [oxygenId] of Object.entries(usersMapByOxygenID)) {
      mapping[oxygenId] = oxygenId;
    }
    return mapping;
  }, [usersMapByOxygenID]);

  return {
    data,
    isLoading: isLoadingUsersMap || !data,
  };
};
